import OrderModalItem from './OrderModalItem';

export default OrderModalItem;
